import React from "react"
import PropTypes from "prop-types"
import { fieldPropTypes } from "redux-form"
import {
  List,
  ListItem,
  ListItemText,
  Checkbox,
  Radio
} from "@material-ui/core"
import { ON_BLUR_CALL_DELAY } from "../../commons/utils"

const FieldList = ({
  children,
  type,
  label,
  placeholder,
  readonly,
  input: { value, onChange, onBlur },
  ...custom
}) => {
  const { items, multiSelection } = custom

  const handleSelection = (item) => {
    if (multiSelection) {
      const newValue = [...value]
      newValue.push(item)
      onChange(newValue)
    }

    if (!multiSelection) {
      onChange(item)
    }

    // Because you can never really "focus" on a FieldList,
    // this is the closest we can get to tracking "losing focus".
    // NOTE: Without setTimeout, the onBlur would be called BEFORE the value changes.
    setTimeout(onBlur, ON_BLUR_CALL_DELAY)
  }

  const handleDeselection = (item) => {
    let newValue = ""

    if (multiSelection) {
      newValue = value.filter((v) => v !== item)
    }

    onChange(newValue)

    // Because you can never really "focus" on a FieldList,
    // this is the closest we can get to tracking "losing focus".
    // NOTE: Without setTimeout, the onBlur would be called BEFORE the value changes.
    setTimeout(onBlur, ON_BLUR_CALL_DELAY)
  }

  return (
    <List>
      {items.map((item) => {
        const isSelected = multiSelection
          ? value.includes(item)
          : value === item
        return (
          <ListItem
            key={item}
            dense
            button
            onClick={() =>
              !isSelected ? handleSelection(item) : handleDeselection(item)
            }
          >
            {multiSelection ? (
              <Checkbox checked={isSelected} />
            ) : (
              <Radio checked={isSelected} />
            )}
            <ListItemText primary={item} />
          </ListItem>
        )
      })}
    </List>
  )
}

FieldList.propTypes = {
  ...fieldPropTypes,
  type: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  readonly: PropTypes.bool
}

FieldList.defaultProps = {
  placeholder: "",
  readonly: false
}

export default FieldList
